import { render, staticRenderFns } from "./ProgressChart.vue?vue&type=template&id=6c980fc2&scoped=true&"
import script from "./ProgressChart.vue?vue&type=script&lang=js&"
export * from "./ProgressChart.vue?vue&type=script&lang=js&"
import style0 from "./ProgressChart.vue?vue&type=style&index=0&id=6c980fc2&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c980fc2",
  null
  
)

export default component.exports